
/**
 * @Desc 多个地方共用的API
 */

import axios from 'axios';
import requester, { Get, Patch, Post, Delete } from 'utils/axios';
import { formatDateTime, localStorageUtil, LastSelectCheck } from 'utils/util';
import { originUrl } from 'config/constant';
import { baseURL, trackBaseURL, _ENV } from 'config/config.js';
import VideoStatistics from 'utils/video-statistics';

/** 
 * @desc 收藏/取消收藏
 * @param {object} param 
 */
export function reqCollectStatus(params) {
  let url = `/api/v1/student/collection/${params.resourceId}`;
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}
/** 
 * 新增历史记录
**/
export function reqAddHistory(params) {
  let url = `/api/v1/student/resource/${params.resourceId}/history`;
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })

}
/** 
 * 资源统计
**/
export function SetVideoStatistics(params) {
  if(_ENV === 'jy') {
    return;
  }
  let accountInfo = localStorageUtil.getItem('accountInfo');
  let userInfo = localStorageUtil.getItem('userInfo');
  if(!userInfo) {
    userInfo = {};
  }
  if(params.resourceId && accountInfo && accountInfo.studentId && VideoStatistics) {
    let obj = {
      type: params.type,
      resourceid: params.resourceId,
      level: params.level,
      subject: params.subject,
      userid: accountInfo && accountInfo.studentId ? accountInfo.studentId : 0,
      customerid: userInfo.customerId ? userInfo.customerId : 0,
      schoolid: userInfo.schoolId ? userInfo.schoolId : 0
    }
    // console.log('video statistics need send params', obj);
    let videoStatistics = new VideoStatistics({
      boxId: params.boxId ? params.boxId : '#videoDivBox',
      trackURL: trackBaseURL + '/api/v1/tracking',
      userType: 1,
      otherTypeInit: params.type === 'preview' || params.type === 'edit' || params.type === 'download' ? obj : null,
      init: params.type ? null : obj,
    });
  }
}

/**
 * @method reqDownLoad
 * @desc 下载
 * @param  {function} progressCb：进度回调函数
 * @param  {function} cancelCb：进度回调函数
 */
export function reqDownLoad(param, progressCb, cancelCb) {
  let url = '';
  let params = {};
  let preUrl = baseURL;
  switch (param.belongType) {
    case 1: // 平台资源
      url = `/api/v1/down/platform/${param.resourceId}`;
      if (param.chapterOneId) {
        params.chapterOneId = param.chapterOneId;
      }
      if (param.chapterTwoId) {
        params.chapterTwoId = param.chapterTwoId;
      }
      if (param.chapterThreeId) {
        params.chapterThreeId = param.chapterThreeId;
      }
      params.resourceId = param.resourceId;
      break;
    case 2: // 共享资源
      url = `/api/v1/down/share/${param.resourceId}`;
      break;
    case 3: // 我的资源
      url = `/api/v1/down/storage/0`;
      params = { documentIds: param.documentIds }
      break;
    case 4: // 我的备课
      url = `/api/v1/down/prepare/${param.resourceId}`;
      break;
    case 'forms': // 教师平台使用明细下载
      url = '/api/v1/userUsedReport/downloadDetail';
      params.queryStartDate = param.queryStartDate;
      params.queryEndDate = param.queryEndDate;
      if (param.customerId) {
        params.customerId = param.customerId;
      }
      if (param.schoolId) {
        params.schoolId = param.schoolId;
      }
      break;
    case 'examination': // 试卷库
      url = `/student/resourceAuthentication/${param.resourceId}`;
      preUrl = originUrl.indexOf('localhost:') === -1 ? originUrl : 'http://student-learning.viewshare.net';
      break;
  }
  const method = 'get'
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  const responseType = 'blob';
  const CancelToken = axios.CancelToken;
  return requester.request({
    method, url, params, timeout: 10800000, baseURL: preUrl, headers, responseType,
    onDownloadProgress: function (progressEvent) {
      progressEvent.uploadId = param.belongType !== 3 ? param.resourceId : param.documentIds;
      progressEvent.fileSize = param.fileSize;
      progressCb && progressCb(progressEvent)
    },
    cancelToken: new CancelToken(function executor(c) {
      cancelCb && cancelCb(c, param.belongType !== 3 ? param.resourceId : param.documentIds)
    })
  })
    .then(res => {
      if(param.needStatistics) {
        SetVideoStatistics({
          resourceId: param.resourceId,
          level: param.levelId,
          subject: param.subjectId,
          type: 'download'
        });
      }
      if(!res) {
        return;
      }
      const content = res.data;
      const blob = new Blob([content]);
      // 设置文件的名称
      let fileName = '';
      if (param.fileName) {
        fileName = param.fileName;
      } else {
        fileName = formatDateTime(new Date(), 'yyyyMMddHHmmss') + '.zip';
      }

      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName;
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
      return Promise.resolve({ id: param.belongType !== 3 ? param.resourceId : param.documentIds })
    })
    .catch(err => {
      return Promise.reject(err)
    })
}



/**
 * @method reqVideoInfo
 * @desc 视频统计发送
 */
export function reqVideoInfo(param) {
  let url = '/api/v1/tracking';
  let data = param;
  let baseURL1 = trackBaseURL;
  const method = 'post'
  const headers = { 'Content-Type': 'application/json;charset=UTF-8' }
  const responseType = '';

  // 创建instance实例
  let instance = axios.create({
    baseURL: baseURL1,
    timeout: 1000 * 20
  });

  return instance.request({
    method,
    url,
    data,
    headers,
    responseType,
  }).then(res => {
    return Promise.resolve(res.data)
  })
    .catch(err => {
      return Promise.reject(err)
    })
}




/** 
 * @desc 获取教材数据及默认版本
 * @param {object} param 
 */
export function reqGetDefaultSubjects(params) {
  let url = params.type === 1 ? '/api/v1/student/subjects' : '/api/v1/topicClasses/catalogs';
  return Get(url, params, false, {
    headers: {
      token: false
    }
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


/**
 * 获取教材数据及默认版本
 * type 1--同步课程 2--专题课
 * **/
export function GetDefaultSubjects(type = 1) {
  // if(type !== 1) { // topic switch
  //   return;
  // }
  return reqGetDefaultSubjects({type})
    .then(res => {
      if (res.code === 0) {
        let _data = res.data;
        for (let i in _data) {
          let val = _data[i];
          if (!val.editionId) {
            for (let n in val.editions) {
              if (val.editions[n].default) {
                val.editionId = n;
                val.editionName = val.editions[n].editionName;
              }
            }
            if (!val.editionId) {
              let _id = Object.keys(val.editions)[0];
              val.editionId = _id;
              val.editionName = val.editions[_id].editionName;
            }
          }
        }
        if(type === 1) {
          localStorageUtil.setItem('subjects', _data);
          let _obj = {
            // "2":[{"editionId":2, "editionName":"部编版"}, {"volumeId":14, "volumeName":"七年级上册"}],
            "subjectId": 2,
            "subjectName": "语文",
            "editionId": 2,
            "editionName": "部编版",
            "volumeId": 14,
            "volumeName": "七年级上册",
            "chapterOneId": null,
            "chapterTwoId": null,
            "chapterThreeId": null
          }
          localStorageUtil.setItem('lastSelect', _obj);
        }else {
          localStorageUtil.setItem('subjects_t', _data);
          let _obj = {
            // "2":[{"editionId":2, "editionName":"部编版"}, {"volumeId":14, "volumeName":"七年级上册"}],
            "subjectId": 2,
            "subjectName": "语文",
            "editionId": 2,
            "editionName": "部编版",
            "volumeId": 14,
            "volumeName": "七年级上册",
            "chapterOneId": null,
            "chapterTwoId": null,
            "chapterThreeId": null
          }
          localStorageUtil.setItem('lastSelect_t', _obj);
          localStorageUtil.setItem('get_t', true);
        }
        LastSelectCheck(type);
        return _data;
      } else {
        this.$message({
          type: "error",
          message: "教材获取失败",
          duration: 2000
        });
      }
      return true;
    })
    .catch(err => {
      console.log("教材获取失败", err);
      return true;
    });
}

/** 
 * 获取百度统计链接字符串
**/
export function reqGetTrackBaiduURL(param) {
  let url = param && param.siteId ? `/api/v1/tracking/${param.siteId}/getSetting` : '/api/v1/tracking/getSetting';
  let params = param;
  let baseURL1 = trackBaseURL;
  const method = 'get';
  const headers = { 'Content-Type': 'application/json;charset=UTF-8' }
  const responseType = '';

  // 创建instance实例
  let instance = axios.create({
    baseURL: baseURL1,
    timeout: 1000 * 20
  });

  return instance.request({
    method, 
    url, 
    params, 
    headers, 
    responseType,
  }).then(res => {
    return Promise.resolve(res.data)
  })
  .catch(err => {
    return Promise.reject(err)
  })
}

/** 
 * 百度统计动态添加
**/
export function TrackingBaiduURL(params) {
  console.log(_ENV);
  if(_ENV === 'jy') {
    return;
  }
  let trackBaiduURL = localStorageUtil.getItem('trackBaiduURL');
  let addBaidu = (data) => {
    var _hmt = _hmt || [];
    window._hmt = _hmt;
    (function() {
      var hm = document.createElement("script");
      hm.src = 'https://hm.baidu.com/hm.js?' + data;
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();
  }
  if(trackBaiduURL) {
    addBaidu(trackBaiduURL);
    let _time = new Date().getTime();
    let _time1 = localStorageUtil.getItem('trackBaiduURLUpdate');
    _time1 = _time1 ? _time1 : _time;
    if(_time - _time1 < 24 * 60 * 60 * 1000) {
      localStorageUtil.setItem('trackBaiduURLUpdate', _time1);
      return;
    }
  }
  return reqGetTrackBaiduURL(params).then(res => {
    if(res.code === 0 && res.data && res.data.jsCode) {
      if(!trackBaiduURL) {
        addBaidu(res.data.jsCode);
      }
      trackBaiduURL = res.data.jsCode;
      localStorageUtil.setItem('trackBaiduURL', trackBaiduURL);
      localStorageUtil.setItem('trackBaiduURLUpdate', new Date().getTime());
      // console.log('reqGetTrackBaiduURL', trackBaiduURL);
    }else {
      console.log('err 百度统计动态url', res);
    }
  }).catch(err => {
    console.log('err 百度统计动态url', err);
  });
}